import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Layout, Label, Button } from 'tigo-components';
import { imageURLs, pageURL_CR } from 'constants/index';
import { Wrapper, Logo, LayoutWrapper } from './styled';
import { getCurrentPosition } from 'utils/utils';
import { texts } from './config';

const CoveragePermission = ({ history }) => {

  const { isProcessing, has, errorCode, message } = useSelector((state) => state.apiStatus.data);

  const {
    apiStatus: { setRequestFailed, clearError },
    auth: { authenticate },
    locationDetails: { updateLocation },
  } = useDispatch();

  const error = has ? { title: errorCode, description: message, type: 'locationError', cssSelector: 'status' } : null;

  useEffect(() => {
    authenticate();
  },[])

  const handleBack = () => history.goBack();

  const getPosition = () => {
    getCurrentPosition()
      .then(({ coords: { latitude, longitude } }) => {
        updateLocation({latitude, longitude})
        history.push(pageURL_CR.coverageMap);
      })
      .catch((err) => {
        setRequestFailed({ errorCode: 500, message: texts.locationError });
      })
  }

  return (
    <LayoutWrapper>
    <Layout
      showHeader
      fullWidth
      loading={isProcessing}
      error={error}
      logo={imageURLs.logo}
      headerShadow
      showBack
      backButtonImage={imageURLs.backButton}
      onBackButtonClick={handleBack}
      clearError={() => clearError()}
    >
      <Wrapper>
        <Label className='heading' text={texts.heading}/>
        <Logo src={imageURLs.goLogo} />
        <Label className='content' text={texts.content} />
        <Label className='subcontent' text={texts.subcontent} />
        <Button
          text={'continuar'}
          variant='rounded'
          onClick={getPosition}
        />
      </Wrapper>
    </Layout>
    </LayoutWrapper>
  );
}

export default CoveragePermission;